import { Api } from "@gogovapps/permits-service-client";
import AppSettings from "../config";

const baseUrl =
  import.meta.env.VITE_REACT_APP_STAGE === "development"
    ? `${AppSettings.GOGOV_BASE_API_URL}/permits`
    : AppSettings.GOGOV_BASE_API_URL;

const PermitsService = new Api({ baseUrl }).permits;

export default PermitsService;
